import React from 'react';

// Components
import Avatar from '@/views/components/avatar/Avatar';
import { Tooltip } from '@/views/components/tooltips';

// Utils
import AvatarType from '../types/avatar';

interface Props {
  avatar: AvatarType;
  tooltip?: boolean;
}

const AvatarPastille = ({ avatar, tooltip }: Props) => {
  const initials = avatar.fname.charAt(0) + avatar.lname.charAt(0);

  if (tooltip) {
    const fullname = `${avatar.fname} ${avatar.lname}`;
    return (
      <Tooltip className="custom-tooltip-v2" message={fullname} place="top">
        <div className="avatar-container">
          <Avatar>{initials}</Avatar>
        </div>
      </Tooltip>
    );
  }

  return (
    <div className="avatar-container">
      <Avatar>{initials}</Avatar>
    </div>
  );
};

export default AvatarPastille;
